import React, { Component } from 'react';
import {Helmet} from 'react-helmet';


class Contact extends Component {

  constructor(props) {
    super(props);
    this.state = {
      yourName: '',
      businessName: '',
      pricingPlan: 0,
      email: '',
      phone: '',
      message: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    let plan = window.location.search.substr(1).split("=")[1],
      message = '';

    const script = document.createElement("script");

    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;

    document.body.appendChild(script);

    message = 'Hello,\n\nI am interested in engaging rewardeclub to create & manage our customers e-club ' +
      'for our business. \n\n' +
      'Please contact me at the above phone or email so I can understand how rewardeclub will help us improve our business.\n\n' +
      'Thanks.';
    this.setState({
      message: message
    });

    if (plan > 0 && plan < 6) {
      document.getElementById('pricingPlan').value = plan;
      this.setState({
        pricingPlan: plan
      });
    } else {
      document.getElementById('pricingPlan').value = 0;
      this.setState({
        pricingPlan: 0
      });
    }
  }

  handleChange = (event) => {

    const name = event.target.name;
    const value = event.target.value;

    this.setState({
      [name]: value
    });

  }

  handleSubmit = (event) => {

    console.log('Submitting form ' + JSON.stringify(this.state));

    if (this.state.yourName === '' || this.state.yourName.length < 5) {
      document.getElementById('yourName').style.border = '3px red solid';
    } else {
      document.getElementById('yourName').style.border = '1px #484c51 solid';
    }

    if (this.state.businessName === '' || this.state.businessName.length < 5) {
      document.getElementById('businessName').style.border = '3px red solid';
    } else {
      document.getElementById('businessName').style.border = '1px #484c51 solid';
    }

    if (this.state.pricingPlan === 0) {
      document.getElementById('pricingPlan').style.border = '3px red solid';
    } else {
      document.getElementById('pricingPlan').style.border = '1px #484c51 solid';
    }

    if (this.state.email === '' || this.state.email.length === 0 ||
      !this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      document.getElementById('email').style.border = '3px red solid';
    } else {
      document.getElementById('email').style.border = '1px #484c51 solid';
    }

    if (this.state.phone === '' || this.state.phone.length < 10) {
      document.getElementById('phone').style.border = '3px red solid';
    } else {
      document.getElementById('phone').style.border = '1px #484c51 solid';
    }

    if (this.state.message === '' || this.state.message.length === 0) {
      document.getElementById('message').style.border = '3px red solid';
    } else {
      document.getElementById('message').style.border = '1px #484c51 solid';
    }

    event.preventDefault();
  }


  render() {
    return (
        <div className="page contact-us" id="page">
          <Helmet>
            <title>rewardeclub | Contact us.</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
            <meta name="description" content="Reach us if you wonder how you can attract more customers." />
            <meta name="keywords" content="eclub, e-club, customer eclub, customer e-club, customers eclub, customers e-club, manage eclub, eclub management, manage e-club, e-club management, connect business and customers" />
            <meta name="robots" content="index, follow" />
          </Helmet>
          <div className="heading">Contact us</div>
          <div className="form">
            <div className="required">* required</div>
            <form onSubmit={this.handleSubmit}>
              <label>
                <input type="text" name="yourName" id="yourName" placeholder="Your Name*" value={this.state.yourName} onChange={this.handleChange} />
                <input type="text" name="businessName" id="businessName" placeholder="Business Name*" value={this.state.businessName} onChange={this.handleChange} />
                <select name="pricingPlan" id="pricingPlan" value={this.pricingPlan} onChange={this.handleChange}>
                  <option value="0">Number of Locations*</option>
                  <option value="1">1 Location</option>
                  <option value="2">2 - 5 Locations</option>
                  <option value="3">6 - 10 Locations</option>
                  <option value="4">11 - 20 Locations</option>
                  <option value="5">21+ Locations</option>
                </select>
                <input type="text" name="email" id="email" placeholder="Email*" value={this.state.email} onChange={this.handleChange} />
                <input type="text" name="phone" id="phone" placeholder="Phone*" value={this.state.phone} maxLength="10"
                  onChange={event => this.setState({phone: event.target.value.replace(/\D/,'')})} />
                <textarea name="message" id="message" placeholder="Message*" value={this.state.message} onChange={this.handleChange} />

              </label>
              <div className="g-recaptcha" data-sitekey="6Le_01EUAAAAALwrxjQnZsiTOVE5azLUGHZzCEw0"></div>
              <input type="submit" className="formSubmit" value="SUBMIT" />
            </form>
          </div>
        </div>

    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/page/Contact.js